module.exports = __webpack_public_path__ + "img/chevron-left-small.24a6eb4d.svg";